<section>
    <h4 class="text-title text-main">NOTÍCIAS</h4>
    <section *ngFor="let item of data" class="artigo">
        <p class="artigo-data">{{item.DataDePublicacao| date: "dd 'de' MMMM" | titlecase}}</p>
        <p class="artigo-text-desc " style="cursor: pointer;" (click)="redirectnoticia(item)">
            <span class="artigo-titulo">{{limitarCaracteresTitulo(item.Title,50) }}</span>
        </p>
        <div [innerHTML]="truncateHTML(item, 100) | safeHtml"></div>
    </section>
</section>
<div class="actions">
    <!--h5><i class="la la-volume-up icon-container"></i> Áudios</h5>
    <h5><i class="la la-camera icon-container"></i> Imagens</h5-->
    <h5><a style="font-size: 1.25rem; color: #002c4f;" routerLink="/videos"><i class="la la-video icon-container"></i> Vídeos</a></h5>
    <h5><a style="font-size: 1.25rem; color: #002c4f;" routerLink="/material-de-apoio/folhetos"><i class="la la-book icon-container"></i> Publicações</a></h5>
</div>